export default "__VITE_ASSET__6d8b0baf__"